import { useState, useEffect } from 'react';
import { useAuth } from '../AuthContext';
import api from '../api';

export const useSubscription = () => {
  const { user, authLoading } = useAuth();
  const [subscription, setSubscription] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (authLoading) return;
    if (!user) { setLoading(false); return; }
    api.get('/subscription/status')
      .then(r => { setSubscription(r.data); setLoading(false); })
      .catch(() => setLoading(false));
  }, [user, authLoading]);

  const isAdmin = user?.ruolo === 'admin' || user?.is_admin;
  const isCollaboratore = user?.ruolo === 'collaboratore';
  const isPro = isAdmin || isCollaboratore || user?.ruolo === 'pro' || subscription?.piano === 'pro';
  const isFree = !isPro;

  return { subscription, loading: loading || authLoading, isPro, isFree, isAdmin, isCollaboratore };
};
